import Cookie from 'cookie';
import { useEffect } from 'react';

/*
 * Helper functions
 */
export const getPostalCode = () => {
  const cookies = Cookie.parse(document.cookie || '');
  const postalCode = cookies?.postalCode ? cookies.postalCode : '';
  return postalCode;
};

export const getLngLat = () => {
  const cookies = Cookie.parse(document.cookie || '');
  const lngLat = cookies?.lngLat ? cookies.lngLat : '';
  return lngLat;
};

export const getProvince = () => {
  const cookies = Cookie.parse(document.cookie || '');
  const province = cookies?.province ? cookies.province : '';
  return province;
};

export const asDollars = (lang, v) => {
  if (v == 0) {
    return '';
  } 
  if (lang == 'fr') {
    return v.toLocaleString('fr-CA', {currency: 'CAD', style: 'currency', maximumFractionDigits: 0, minimumFractionDigits: 0, });
  }
  return v.toLocaleString('en-CA', { currency: 'CAD', style: 'currency', maximumFractionDigits: 0, minimumFractionDigits: 0,  });
};
export const asCurrency = (lang, v) => {
  /* if (v == 0) {
    return '';
  } */
  if (lang == 'fr') {
    return v.toLocaleString('fr-CA', {currency: 'CAD', style: 'currency', maximumFractionDigits: 2, minimumFractionDigits: 0, });
  }
  return v.toLocaleString('en-CA', { currency: 'CAD', style: 'currency', maximumFractionDigits: 2, minimumFractionDigits: 0,  });
};
export const getUniqueIdFromELOQUA = () => {
  const cookies = Cookie.parse(document.cookie || '');
  const uniqueId = cookies.ELOQUA ? cookies.ELOQUA : 'unknown';
  return uniqueId;
};
